import { useState, useEffect } from 'react';
import { useDebounceFn } from 'ahooks';
import { request } from '@/utils/request';
import { QAItem } from '@/pages/knowledge/components/productQA-item';

type FetchOptions = { [key: string]: string | number }

export default function useFetch(url: string, options: FetchOptions, dispatchFetchValue?: (value: any) => void) {
  const [data, setData] = useState<any>([]);
  const [total, setTotal] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    fetchData();
  }, []);

  /** @description 获取流程图列表数据 防抖 */
  const { run: fetchData } = useDebounceFn(
    async (newItem = null) => {
      if (newItem) {
        if (newItem.type === 'update') {
          setData(data.map((vo: QAItem) => {
            const qa = newItem.value.find((n: any) => n.from === vo.id);
            if (qa) {
              return {
                ...vo,
                ...qa.to
              };
            }
            return vo;
          }));
        } else if (newItem.type === 'add') {
          const preIndex = data.findIndex((vo: any) => vo.id === newItem.value[0].from);
          setData([...data.slice(0, preIndex), newItem.value.map((vo: any) => vo.to), ...data.slice(preIndex)]);
        }
        return;
      }
      setLoading(true);
      try {
        let { resp } = await request(url, {
          method: 'get',
          params: options,
        });
        if (resp?.code !== 0) setData([]);
        setData(resp?.data.list);
        if (dispatchFetchValue) dispatchFetchValue({ type: 'update', value: { total: resp?.data.total } });
      } catch {
        setData([]);
      } finally {
        setLoading(false);
      }
    },
    { wait: 300 },
  );

  return { data, total, loading, fetchData };
}